import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { faLinkedin, faFacebook, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import logo from '../images/new_logo.svg';
import profile from '../images/new_logo.svg';
import algoliasearch from "algoliasearch";
import ShowResults from './ShowResults';
import { isNotEmpty, signupCall, loginCall } from "../util/user";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faFlagCheckered, faGift, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faBell, faMoneyBillAlt, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import logoSmall from '../images/new_logo.svg';
import { AuthContext } from "../util/context";
import renderIf from "render-if";
import header from '../images/header.jpg';

class VidBox extends React.Component {
  constructor(props) {
    var client = algoliasearch('PTGN8U7BAB', '1bd38ecdf030101a4cff6d2447e8de2e');

    super(props);
    this.state = {
      loading: true,
      searchingFor: "",
      priceMax: undefined,
      priceMin: undefined,
    };

    this.handleChange = this.handleChange.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
  }

  _handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.goToSearch()
    }
  }

  goToSearch() {
    const url = `/browse?search=${encodeURIComponent(this.state.searchingFor)}&min_price=${encodeURIComponent(this.state.priceMin)}&max_price=${encodeURIComponent(this.state.priceMax)}`;
    this.props.history.push(url);
  }

  handleChange(field, e) {
    const state = this;
    this.setState({[field]: e.target.value});
  }

  render () {
    return (
      <div className="vid-box parallax bg1">
        <div className="search-text">
          <div className="search-ctn">
            <h2>Find your perfect home</h2>
            <h1>Today</h1>


            <button className="button" onMouseDown={this.goToSearch}>
              View All Listings
            </button>
          </div>
        </div>

        <img src={"https://ganz.ourubertor.com//templates/ganz/banners/banner.jpg"} className="transparent-overlay"/>
      </div>
    );
  }
};

export default withRouter(VidBox);
